import { FormControl, Input, TextField } from "@mui/material";
import styled from "styled-components";

export const LoginHeader = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`;

export const LoginHeaderText = styled.span`
  font-size: 35px;
  text-align: left;
  font-family: "Bold";
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 50px;
  }
`;

export const LoginHeaderLogo = styled.img`
  width: 60px;
  height: 60px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 80px;
    height: 80px;
  }
`;

export const LoginWrapper = styled.div`
  width: 100%;
  height: 70%;
  display: flex;

  align-items: center;
  flex-direction: column;
  gap: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 40px;
  }
`;

export const AccountLogin = styled.button`
  width: 300px;
  height: 50px;
  border-radius: 5px;
  background-color: #f44b59;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 1px 5px #808080;

  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 70px;
  }
`;
export const KakaoLoginButton = styled.button`
  width: 300px;
  height: 50px;
  border-radius: 5px;
  /* background-color: #f9e000; */
  background-color: #ffde00;
  display: flex;
  align-items: center;

  border: none;
  box-shadow: 0 1px 5px #808080;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 70px;
  }
`;

export const KaKaoLogoWrapper = styled.div`
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const KakaoLogo = styled.img`
  width: 30px;
  height: 30px;

  @media ${({ theme }) => theme.device.tablet} {
    width: 50px;
    height: 50px;
  }
`;

export const KakaoTextWrapper = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Email = styled(TextField)`
  width: 300px;
  height: 50px;

  // 크롬 아이디 자동완성시 기본 배경색 제거
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  .MuiInputBase-input {
    font-size: 18px;
    font-family: "Bold";
  }

  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }

  @media ${({ theme }) => theme.device.tablet} {
    width: 620px;
    height: 100px;
    .MuiInputBase-input {
      font-size: 28px;
    }
  }
`;

export const PasswordWrapper = styled(FormControl)`
  width: 300px;
  height: 50px;
  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }
  .MuiInputBase-input {
    font-size: 18px;
    font-family: "Bold";
    /* text-align: center; */
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 620px;
    height: 100px;
    .MuiInputBase-input {
      font-size: 35px;
    }
  }
`;

export const PasswordInput = styled(Input)`
  // 크롬 아이디 자동완성시 기본 배경색 제거
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
`;

export const Password = styled(TextField)`
  width: 300px;
  height: 50px;
  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }
  .MuiInputBase-input {
    font-size: 18px;
    font-family: "Bold";
    /* text-align: center; */
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 620px;
    height: 100px;
    .MuiInputBase-input {
      font-size: 28px;
    }
  }
`;

export const LabelText = styled.span`
  font-size: 18px;

  font-family: "Bold";
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 30px;
  }
`;

export const Register = styled.div`
  width: 300px;
  height: 15px;
  text-align: center;
  font-family: "Regular";
  font-size: 10pt;
  color: gray;
  margin-top: 15px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 20px;
  }
`;
